const ActionTypes = {
    AuthGoogle: 'AuthGoogle',
    AuthFacebook: 'AuthFacebook',
    AuthWithEmail: 'AuthWithEmail',
    AuthSuccess: 'AuthSuccess',
    LoginWithEmail: 'LoginWithEmail',
    PasswordRest: 'PasswordRest',
    LogOutSession: 'LogOutSession',
    FavoriteData: 'FavoriteData',
    EditProfile: 'EditProfile',
    LinkedWithPopup: 'LinkedWithPopup',

    LoginError: 'LoginError',
    loginLoader: 'loginLoader',
    PasscodeError: 'PasscodeError',
    LoadingInstant: 'LoadingInstant',
    LoadingFb: 'LoadingFb',
    passCodeLoader: 'passCodeLoader',
    LoaderAccount: 'LoaderAccount',
    EditLoader: 'EditLoader',
    EditMessage: 'EditMessage',

    AllSharedData: 'AllSharedData',
    CurrentQuiz: 'CurrentQuiz',
    QuizDetails: 'QuizDetails',
    length: 'length',
    Favorite: 'Favorite',
    FavoriteFlag: 'FavoriteFlag',
    FavoriteError: 'FavoriteError',
    FavoriteErrorFlag: 'FavoriteErrorFlag',

    PlayOptions: 'PlayOptions',
    PlayingKey: 'PlayingKey',
    SETCURRENTQUIZ: 'SETCURRENTQUIZ',
    PlayingQuiz: 'PlayingQuiz',
  
    ScoreView: 'ScoreView',
    ResultForDownload: "ResultForDownload",
    NoResultForDownload: "NoResultForDownload",
    resultLoading: 'resultLoading'

} 
export default ActionTypes;


// WEBPACK FOOTER //
// ./src/reducers/container/actionType.jsx